import * as React from 'react';

import SelectComponent, { SelectComponentProps } from './Select.component';

interface SelectContainerProps {
  label?: string;
  defaultValue?: string;
  value?: string;
  handleChange: (value: string) => void;
  addEmptyOption?: boolean;
  className?: string;
  itemSet: { name: string; value: string; }[];
}

export default class SelectContainer extends React.Component<SelectContainerProps> {

  public onChange(value: string): void {
    this.props.handleChange(value);
  }

  public render(): React.ReactNode {
    return (
      <SelectComponent {...this.getComponentProps()}/>
    );
  }

  private getComponentProps(): SelectComponentProps {
    return {
      label: this.props.label,
      defaultValue: this.props.defaultValue,
      value: this.props.value,
      options: this.props.itemSet,
      addEmptyOption: this.props.addEmptyOption || false,
      handleChange: this.props.handleChange,
      className: this.props.className,
    };
  }
}



// WEBPACK FOOTER //
// ./src/modules/commons/inputs/bootstrap-select/Select.container.tsx